module.exports = __webpack_public_path__ + "assets/icons/ic_edit-22de.svg";